import React, { useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';


function DownloadPatientData() {
  const { ItemList } = useSelector((state) => state.users);
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'Doctor Data',
  });
useEffect(()=>{
handlePrint()
})
  return (
    <div ref={componentRef} style={{ width: '100%', height: '100%', padding: '20px' }}>
      <div style={{ marginBottom: '20px' }}>
        <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Patient Data</h1>
        <Button onClick={handlePrint} variant="primary" style={{ float: 'right' }}>Print</Button>
      </div>
      <table className="table table-striped">
        <thead>
          <tr>
            <th>S.No.</th>
            <th>Registration Date</th>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Gender</th>
            <th>Address</th>
            <th>Status</th>
            <th>Total Appointment</th>
          </tr>
        </thead>
        <tbody>
          {ItemList.map((patient, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{patient.registrationDate}</td>
              <td>{patient.name}</td>
              <td>{patient.email}</td>
              <td>{patient.mobile}</td>
              <td>{patient.gender}</td>
              <td>{patient.address}</td>
              <td>{patient.status}</td>
              <td>{patient.appointmentCount}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {/* <Button onClick={handlePrint}>Print</Button> */}
    </div>
  );
}

export default DownloadPatientData;
